import React from 'react'
import styled from 'styled-components'
import Image from 'material-ui-image'

import {
  Box,
  Card as MuiCard,
  CardContent,
  LinearProgress,
  Typography,
} from '@material-ui/core'
import { spacing } from '@material-ui/system'

const Card = styled(MuiCard)(spacing)

interface ImageGalleryProps {
  title: string
  loading?: boolean
  images?: { url: string }[]
}

const ImageGallery = (props: ImageGalleryProps) => {
  const { title, loading = false, images } = props
  return (
    <Card mb={6}>
      <CardContent>
        <Typography variant="h5" component="h2">
          {title}
        </Typography>
        {loading ? (
          <LinearProgress />
        ) : (
          <>
            {images ? (
              images.map((img, index) => (
                <Box key={index} width="20%">
                  <Image src={img.url} />
                </Box>
              ))
            ) : (
              <Typography>No images.</Typography>
            )}
          </>
        )}
      </CardContent>
    </Card>
  )
}

export default ImageGallery
